import { Controller } from "@hotwired/stimulus"
import noUiSlider from "nouislider"

export default class extends Controller {
  static targets = ["slider", "input"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    start: { type: Array, default: [20] },
    step: Number,
    connect: { type: String, default: "true" },
    tooltips: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }

  connect() {
    this.initSlider()
  }

  disconnect() {
    if (this.slider && this.slider.noUiSlider) {
      this.slider.noUiSlider.destroy()
    }
  }

  initSlider() {
    if (!this.hasSliderTarget) return

    this.slider = this.sliderTarget

    const options = {
      start: this.startValue,
      range: {
        min: this.minValue,
        max: this.maxValue
      },
      connect: this.parseConnect()
    }

    if (this.hasStepValue) {
      options.step = this.stepValue
    }

    if (this.tooltipsValue) {
      options.tooltips = this.startValue.map(() => ({
        to: (value) => Math.round(value),
        from: (value) => Number(value)
      }))
    }

    noUiSlider.create(this.slider, options)

    if (this.disabledValue) {
      this.slider.setAttribute("disabled", true)
    }

    this.slider.noUiSlider.on("update", (values, handle) => {
      this.updateInput(values)
      this.dispatch("update", { detail: { values, handle } })
    })

    this.slider.noUiSlider.on("change", (values, handle) => {
      this.dispatch("change", { detail: { values, handle } })
    })
  }

  parseConnect() {
    try {
      const parsed = JSON.parse(this.connectValue)
      return parsed
    } catch {
      return this.connectValue === "true"
    }
  }

  updateInput(values) {
    if (!this.hasInputTarget) return

    if (values.length === 1) {
      this.inputTarget.value = Math.round(values[0])
    } else {
      this.inputTarget.value = JSON.stringify(values.map(v => Math.round(v)))
    }
  }

  setValue(value) {
    if (!this.slider || !this.slider.noUiSlider) return

    this.slider.noUiSlider.set(value)
  }

  getValue() {
    if (!this.slider || !this.slider.noUiSlider) return null

    return this.slider.noUiSlider.get()
  }

  enable() {
    if (!this.slider) return

    this.slider.removeAttribute("disabled")
  }

  disable() {
    if (!this.slider) return

    this.slider.setAttribute("disabled", true)
  }

  reset() {
    this.setValue(this.startValue)
  }
}
